<template>
<div class="container element-margin">
  <transition name="fade">
    <div class="" v-if="newcalcvis">
      <NewCalc />
    </div>
  </transition>
    <b-container class="estisize formback bv-example-row box" v-if="rewidgvis">
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="auto" style="color:darkgrey;">
          <h3>Submit estimate:</h3>
        </b-col>
      </b-row>
      <b-row align-h="center" class="mt-3">
        <b-col cols="10" md="auto" text-center>
          <input v-model="repairOfferAmount" type="number" class="form-control my-auto centered-input" ref="estimate" placeholder="Enter amount">
        </b-col>
      </b-row>
      <b-col align-self="center">
        <b-button :disabled="!repairOfferAmount" variant="success" @click="submit();onpicOne()">Next</b-button>
      </b-col>
    </b-container>
    <transition name="fade">

      <div v-if="visible" class="vue-back-to-top" :style="`bottom:${this.bottom};left:${this.left};`">
        <Main />
      </div>
    </transition>

</div>
</template>

<script>
export default {
  name: 'Rewidg',
  data() {
    return {
      step:2,
      repairOfferAmount: '',
      newcalcvis: false,
      rewidgvis: true,
      visible: false
    }
  },
  computed: {

    carSpec() {
      return this.$store.state.userData.carDetails.substring(0, 4)
    },
  },
  mounted() {
    if (!this.$store.state.userData.carDetails) {
      this.$router.push({
        name: 'Home',
      })
    }
    this.$refs.estimate.focus();
    if(this.$store.state.userData.repairOfferAmount){
      this.repairOfferAmount = this.$store.state.userData.repairOfferAmount
    }

  },

  methods: {
    closereseize(){
      if ('parentIFrame' in window)
      window.parentIFrame.size(70);
      return false;
    },
    closeWin(){
      return [this.rewidgvis = false, this.visible = true]
    },
    onpicOne() {
      if ('parentIFrame' in window)
      window.parentIFrame.size(703);
      return false;
    },
    submit() {
      this.$store.state.userData.repairOfferAmount = this.repairOfferAmount
      this.$store.state.userData.step = 3
      this.newcalcvis = true
      this.rewidgvis = false

    },
  },
}
</script>

<style scoped>
.formback {
  background-color: white;
}

@media screen and (max-width: 430px){
  .estisize{
    width:200px
  }
}

@media screen and (min-width: 431px){
  .estisize{
    width:340px
  }
}

.element-margin {
  text-align: center;
}


.box {
  padding-top: 1rem;
  padding-bottom: 2rem;
  border-radius: 10px;
}

.box .separator .line {
  width: 1px;
  height: 40%;
  background-color: #a803a8;
}

.box .separator .or {
  width: fit-content;
  height: 20%;
  display: flex;
  align-items: center;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 3.5rem;
  color: #fff;
  margin: 0 auto;
  display: block;
  margin-top: 3rem;
}

select,
input {
  margin-top: 1.5rem;
  border-radius: 1rem;
}

select:focus,
input:focus {
  box-shadow: none;
}

.input-container input {
  width: 250px;
}

.input-container select {
  width: 70px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}

ele div.x {
  -webkit-transition-duration: 0.5s;
  transition-duration: 0.5s;
  display: inline;
  float: right;
}

.ele div.x.slow {
  -webkit-transition-duration: 1s;
  transition-duration: 1s;
}

ul {
  list-style: none;
  float: right;
  display: block;
  width: 100%;
}

li {
  display: inline;
  width: 25%;
  float: right;
}

.ele {
  width: 25%;
  display: inline;
}

.x {
  float: left;
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: #CCC;
  border-radius: 2px;
  border: solid 2px #FFF;
  transition: all .3s ease-out;
  cursor: pointer;
}

.x.large {
  width: 33px;
  height: 33px;
}

.x.medium {
  width: 20px;
  height: 20px;
}

.x.small {
  width: 10px;
  height: 10px;
}

.x.switch {
  width: 15px;
  height: 15px;
}

.x.grow {}

.x.spin:hover {
  background: #40c991;
  transform: rotate(180deg);
}

.x.flop:hover {
  background: #40c991;
  transform: rotate(90deg);
}

.x.t:hover {
  background: #40c991;
  transform: rotate(45deg);
}

.x.shift:hover {
  background: #40c991;
}

.x b {
  display: block;
  position: absolute;
  height: 0;
  width: 0;
  padding: 0;
  margin: 0;
}

.x.small b {
  border: solid 5px rgba(255, 255, 255, 0);
}

.x.medium b {
  border: solid 10px rgba(255, 255, 255, 0);
}

.x.large b {
  border: solid 15px rgba(255, 255, 255, 0);
}

.x.switch b {
  border: solid 10px rgba(255, 255, 255, 0);
}

.x b:nth-child(1) {
  border-top-color: #FFF;
  top: -2px;
}

.x b:nth-child(2) {
  border-left-color: #FFF;
  left: -2px;
}

.x b:nth-child(3) {
  border-bottom-color: #FFF;
  bottom: -2px;
}

.x b:nth-child(4) {
  border-right-color: #FFF;
  right: -2px;
}

.checkmark {
  display: block;
  margin: 0 auto;
  text-align: center;
}

.checkmark:after {
  content: '';
  display: block;
  border: solid #000;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkmark.large:after {
  width: 12px;
  height: 24px;

}

.checkmark.medium:after {
  width: 8px;
  height: 16px;

}

.checkmark.small:after {
  width: 4px;
  height: 8px;
}

.checkmark.tiny:after {
  width: 1px;
  height: 2px;
  border-width: 0 1px 1px 0;
}
.centered-input {
  text-align: center;
  padding: 0 10px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/rewidg.vue